import Swal from 'sweetalert2';

const toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2800,
  timerProgressBar: true,
});

export const notifySuccess = (message, title = 'Success') => {
  return toast.fire({
    icon: 'success',
    title,
    text: message,
  });
};

export const notifyWarning = (message, title = 'Warning') => {
  return toast.fire({
    icon: 'warning',
    title,
    text: message,
  });
};

export const notifyError = (message, title = 'Error') => {
  return Swal.fire({
    icon: 'error',
    title,
    text: message,
    confirmButtonText: 'OK',
  });
};

export const notifyInfo = (message, title = 'Info') => {
  return toast.fire({
    icon: 'info',
    title,
    text: message,
  });
};

export const confirmAction = async ({
  title = 'Are you sure?',
  text = '',
  confirmButtonText = 'Yes',
  cancelButtonText = 'Cancel',
  icon = 'warning',
} = {}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    reverseButtons: true,
    focusCancel: true,
  });

  return result.isConfirmed;
};
